import React, { Component } from 'react';
import BlockTableRow from '../BlockTableRow';

class BlockTable extends Component {
  render() {
    const { blocks, onDelete } = this.props;
    return (
      <div className="block-table py-3">
        <BlockTableRow header />
        {blocks.length > 0 ? (
          blocks.map((block, index) => (
            <BlockTableRow
              key={index}
              block={block}
              onDelete={onDelete}
              // onSelect={onSelect}
              // selectedBlockId={selectedBlockId}
            />
          ))
        ) : (
          <BlockTableRow isEmpty />
        )}
      </div>
    );
  }
}

export default BlockTable;



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/Availability/Specific/BlockTable/index.js